import { GET_BOOKER_TICKET } from '../_types';

const initialState = {};

const bookerTicketReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_BOOKER_TICKET: {
      return payload;
    }

    default:
      return state;
  }
};

export default bookerTicketReducer;
